import React from "react";
import { Spinner } from "reactstrap";

export const SpinnerComponent = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{ height: "100%" }}
    >
      <Spinner color="secondary">Loading...</Spinner>
    </div>
  );
};
